import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';

const ReferralBanner = ({ facilityName, mobileShow }) => {
  return (
    facilityName && (
      <div
        className={`referral-banner ${
          !mobileShow ? 'referral-banner-hide' : ''
        }`}
      >
        <Container>
          <div>
            <span className="font-weight-bold">Welcome!</span> You have been
            sent to us by {facilityName}.
          </div>
        </Container>
      </div>
    )
  );
};

ReferralBanner.propTypes = {
  facilityName: PropTypes.string,
  mobileShow: PropTypes.bool.isRequired,
};

ReferralBanner.defaultProps = {
  facilityName: null,
};

export default ReferralBanner;
